module.exports = __webpack_public_path__ + "static/media/100-logo-black.590b7286.svg";